import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    width: 0;\n    height: 0;\n    border-style: solid;\n    border-width: 9.5px\n        ", "\n        9.5px\n        ", ";\n    border-color: transparent\n        ", "\n        transparent\n        ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    & + & {\n        margin-left: 12px;\n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    float: right;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 8px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { Button } from '../Button';
import { Typography } from '../Typography';
var StyledDatepickerHeader = styled.div(_templateObject());
var Month = styled(Typography)(_templateObject2());
var MonthChangeButtons = styled.div(_templateObject3());
var MonthChangeButton = styled(Button)(_templateObject4());
var MonthChangeArrow = styled.div(_templateObject5(), function (_ref) {
  var direction = _ref.direction;
  return direction === 'left' ? '12px' : '0';
}, function (_ref2) {
  var direction = _ref2.direction;
  return direction === 'left' ? '0' : '12px';
}, function (_ref3) {
  var direction = _ref3.direction;
  return direction === 'left' ? 'currentColor' : 'transparent';
}, function (_ref4) {
  var direction = _ref4.direction;
  return direction === 'left' ? 'transparent' : 'currentColor';
});
export function DatepickerHeader(locale) {
  function DatepickerHeaderComponent(props) {
    var date = props.date,
        decreaseMonth = props.decreaseMonth,
        increaseMonth = props.increaseMonth,
        prevMonthButtonDisabled = props.prevMonthButtonDisabled,
        nextMonthButtonDisabled = props.nextMonthButtonDisabled;
    return React.createElement(StyledDatepickerHeader, null, React.createElement(MonthChangeButtons, null, React.createElement(MonthChangeButton, {
      variant: 'text',
      size: 'large',
      disabled: prevMonthButtonDisabled,
      onClick: decreaseMonth
    }, React.createElement(MonthChangeArrow, {
      direction: 'left'
    })), React.createElement(MonthChangeButton, {
      variant: 'text',
      size: 'large',
      disabled: nextMonthButtonDisabled,
      onClick: increaseMonth
    }, React.createElement(MonthChangeArrow, {
      direction: 'right'
    }))), React.createElement(Month, {
      variant: 'h2',
      display: 'block',
      ellipsis: true
    }, format(date, 'LLLL', {
      locale: locale
    })), React.createElement(Typography, {
      variant: 'h4',
      display: 'block'
    }, format(date, 'yyyy', {
      locale: locale
    })));
  }

  return DatepickerHeaderComponent;
}